import React from "react";
import { Link } from "react-router-dom";
import "../css/NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found-container">
      <img src="/TESTDEMO/404.png" alt="404 Not Found" className="not-found-image" />
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="home-link">Go Back Home</Link>
    </div>
  );
};

export default NotFound;
